var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0.75C1.0625 0.75 0.5 1.3125 0.5 2C0.5 2.6875 1.0625 3.25 1.75 3.25C2.4375 3.25 3 2.6875 3 2C3 1.3125 2.4375 0.75 1.75 0.75ZM14.25 0.75C13.5625 0.75 13 1.3125 13 2C13 2.6875 13.5625 3.25 14.25 3.25C14.9375 3.25 15.5 2.6875 15.5 2C15.5 1.3125 14.9375 0.75 14.25 0.75ZM8 0.75C7.3125 0.75 6.75 1.3125 6.75 2C6.75 2.6875 7.3125 3.25 8 3.25C8.6875 3.25 9.25 2.6875 9.25 2C9.25 1.3125 8.6875 0.75 8 0.75Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.6488fdbe9e9b3431880a92b7727d3e54.svg";
export { ForwardRef as ReactComponent };